const routes = {
  register: '/',
  login: '/login',
  projects: '/projects',
  sprints: '/projects/:projectId',
  tasks: '/projects/:projectId/:sprintId',
};

export default routes;
